<template>
    <div class="layout" :class="{'layout__canvas-open': showCanvas}">
        <layout-header :hide-search="hideSearch" :show-canvas="hasCanvas" @toggle="toggleCanvas"/>
        <layout-canvas v-if="hasCanvas" :hide-search="hideSearch" :nav-items="navItems" :is-open="showCanvas"  @toggle="toggleCanvas"/>

        <div class="layout--inner">
            <div class="layout--sidebar-left">
                <sticky>
                    <layout-navigation :nav-items="navItems"/>
                </sticky>
            </div>
            <div class="layout--content">
                <slot/>
            </div>
        </div>
        <layout-footer/>

        <sticky class="layout--background"/>
    </div>
</template>

<style lang="scss">
    .layout {
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 100%;
        background-color: $dark-5;
        padding-top: $layout-header-height;
    }
    .layout--inner {
        display: flex;
        flex-grow: 1;
        max-width: $layout-max-width;
        width: 100%;
        margin: 0 auto;
        padding: $spacer-3;
        z-index: 1;
    }
    .layout--sidebar-left {
        width: $layout-sidebar-width;
        flex-shrink: 0;
        z-index: 0;
        > .sticky {
            z-index: 1;
        }
    }
    .layout--content {
        min-width: 0;
        width: 100%;
        margin-left: $spacer-2;
        flex-grow: 1;
    }
    .layout--background {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: transparent url("/img/start-logo-schwarz.svg") no-repeat bottom left;
        opacity: .02;
        background-size: 35%;
        z-index: 0;
    }

    .ie11 {
        .layout {
            padding-bottom: 110px;
        }
        .layout-footer {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }

    @include media-breakpoint-down("lg") {
        .layout--content {
            margin-left: 0;
        }
        .layout--sidebar-left {
            display: none;
        }
    }@include media-breakpoint-down("md") {
        .layout--background {
            display: none;
        }
    }
    @include media-breakpoint-down("sm") {
        .layout--inner {
            padding: $spacer-2;
        }
        .layout-footer--inner {
            display: none;
        }
    }
    @include media-breakpoint-down("xs") {
        .layout--inner {
            padding: $spacer-1;
        }
    }
</style>

<script>
    export default {
        props: {
            hideSearch: {type: Boolean, default: false},
            navItems: {type: Array, default: () => []},
        },

        data() {
            return {
                showCanvas: false,
            };
        },

        computed: {
            hasCanvas() {
                return this.navItems.length > 0 && !this.hideSearch;
            },
        },

        methods: {
            toggleCanvas() {
                this.showCanvas = !this.showCanvas;
            },
        },
    };
</script>